import { Link } from "react-router-dom";

export default function ArticleFooter() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-10">
        <div className="text-center">
          <Link to="/" className="inline-block mb-3">
            <span className="font-heading text-xl font-bold text-primary-600">
              itaobuy<span className="text-accent-500">.team</span>
            </span>
          </Link>
          <p className="text-xs text-foreground-500 mb-4">
            Your trusted hub for itaobuy sheet comparisons, rankings, and comprehensive guides.
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              &larr; Back to Home
            </Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              Main Platform
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              Itaobuy Sheet
            </a>
          </div>
          <p className="mt-4 text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} itaobuy.team — All rights reserved. Updated Daily.
          </p>
        </div>
      </div>
    </footer>
  );
}